<template>
    <BRow>
        <BCol>
            <BCard 
                bg-variant="primary" 
                footer-bg-variant="primary" 
                v-if="message.role === 'user'" 
                class="float-end m-3 w-75"
                footer-tag="small">            
                <MessageContent :text="message.text"></MessageContent>
                <template #footer>
                    <small class="text-mute float-end">
                        {{ toLocaleDateTimeString(message.createdAt) }}
                    </small>
                </template>
            </BCard>
            <BCard 
                v-else 
                bg-variant="light" 
                footer-bg-variant="light" 
                class="float-start m-3 w-75"
                footer-tag="small">
                <MessageContent :text="message.text"></MessageContent>
                <template #footer>
                    <small class="text-mute">
                        {{ toLocaleDateTimeString(message.createdAt) }}
                    </small>
                </template>
            </BCard>
        </BCol>
    </BRow>

</template>
<script>
import MessageContent from './MessageContent.vue';

export default {
  name: 'MessageBubble',
  components: {
    MessageContent,
  },
    // message: id, role, text, createdAt
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toLocaleDateTimeString(dateTime) {
      const date = new Date(dateTime);
      return date.toLocaleString();
    },
  },
};
</script>
